import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import AuthLayout from "./AuthLayout";
import { api, apiError } from "@/lib/api";
import { Field, ErrorState } from "@/components/common";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data.message);
    } catch (e2) { setErr(apiError(e2)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title="Reset password" subtitle="We'll email you a secure, single-use link.">
      {done ? (
        <div data-testid="forgot-password-success" className="flex gap-3 p-4 rounded-xl border border-[#4BE3A4]/30 bg-[#4BE3A4]/5 text-sm text-[#F7FAFF]">
          <CheckCircle2 size={16} className="text-[#4BE3A4] mt-0.5 shrink-0" /> {done}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
          <Field label="Email"><input data-testid="forgot-email-input" type="email" required className="cq-input" value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          {err && <ErrorState message={err} />}
          <button data-testid="forgot-submit-button" disabled={busy} className="cq-btn cq-btn-primary w-full !py-2.5">
            {busy && <Loader2 size={14} className="animate-spin" />} Send reset link
          </button>
        </form>
      )}
      <Link data-testid="back-to-login-link" to="/login" className="mt-6 inline-block text-sm text-[#22E6F2] hover:underline">Back to sign in</Link>
    </AuthLayout>
  );
}
